import { render, staticRenderFns } from "./article10.vue?vue&type=template&id=52d521cc&scoped=true"
import script from "./article10.vue?vue&type=script&lang=js"
export * from "./article10.vue?vue&type=script&lang=js"
import style0 from "./article10.vue?vue&type=style&index=0&id=52d521cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d521cc",
  null
  
)

export default component.exports